import './services.css';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

import engineering from '../../assets/images/engineering.jpg';
import mechanicalProcessing from '../../assets/images/mechanicalProcessing.jpg';
import coating from '../../assets/images/coating.jpg';
import welding from '../../assets/images/welding.jpg';
import bending from '../../assets/images/bending.jpg';
import laser from '../../assets/images/laser.jpg';

export const services = [
  {
    id: 'laser',
    title: 'Лазерная резка',
    image: laser,
    slug: 'laser-rezka'
  },
  {
    id: 'bending',
    title: 'Гибка металла',
    image: bending,
    slug: 'gibka-metalla'
  },
  {
    id: 'welding',
    title: 'Сварочные работы',
    image: welding,
    slug: 'svarochnye-raboty'
  },
  {
    id: 'mechanical-processing',
    title: 'Механическая обработка',
    image: mechanicalProcessing,
    slug: 'meh-obrabotka'
  },
  {
    id: 'engineering',
    title: 'Инжиниринг и проектирование',
    image: engineering,
    slug: 'inginiring'
  },
  {
    id: 'coating',
    title: 'Порошковая покраска',
    image: coating,
    slug: 'pokraska'
  }
];

export default function Services() {
  const mobileSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  };

  return (
    <section id="uslugi" className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2>Наши услуги</h2>
        </div>

        {/* Мобильный слайдер через React Slick — отображается только на мобильных */}
        <div className="mobile-slider">
          <Slider {...mobileSliderSettings}>
            {services.map((item) => (
              <div className="slider-slide" key={item.id}>
                <div className="services-card">
                  <div className="services-title">{item.title}</div>
                  <img
                    src={item.image}
            className="services-image"
            alt={item.title}
                  />
                  <Link to={`/services/${item.slug}`} className="services-link">
            Подробнее
                  </Link>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Грид для десктопа — показываем только на больших экранах */}
        <div className="services-grid">
          {services.map((item) => (
            <div className="services-card" key={item.id}>
              <div className="services-title">{item.title}</div>
              <img
                src={item.image}
                className="services-image"
                alt={item.title}
              />
              <Link to={`/services/${item.slug}`} className="services-link">
                Подробнее
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
